import React, { useEffect, useState }        from 'react';
import { Row }                               from 'reactstrap';
import { siteSummaryService }  from "../../services";
import { dateFormatMonthDayYearHoursMinute } from "../../actions/util";
import { useLocation }                       from "react-router-dom";
import { useForm }                           from "react-hook-form";
import { CheckIt, MyPagination }             from "../index";
import { addSiteSummaryAction }              from "../../actions/siteSummary";
import { userActionsKeys }             from "../../util/userActions";
import { useAllName, useDefaultLimit } from "../../hooks";

const SiteSummary = () => {

  const {defaultLimit} = useDefaultLimit()
  const location = useLocation();
  const {register, handleSubmit, setValue, errors} = useForm();
  const [siteSummaries, setSiteSummaries] = useState([]);
  const [pagination, setPagination] = useState({limit: defaultLimit, skip: 0, filterName: "", columnSort: "", descending: true});
  const {getName} = useAllName();

  let param = location.search;

  const visitId = new URLSearchParams(param).get("visit");

  const getVisit = (limit = pagination.limit, skip = pagination.skip, filterName = pagination.filterName, columnSort = pagination.columnSort, descending = pagination.descending) => {
    siteSummaryService()
      .getSiteSummaries(visitId, limit, skip, filterName, columnSort, descending)
      .then(res => {
        if (res && res.data) {
          setSiteSummaries(res.data);
          setPagination({
            ...pagination,
            count: parseInt(res.headers['x-total-count'], 10),
            limit: parseInt(res.headers['x-total-limit'], 10),
            skip: parseInt(res.headers['x-total-skip'], 10),
            columnSort,
            descending
          })
        }
      })
  };

  useEffect(() => {
    if (param) {
      if (visitId) {
        getVisit()
      }
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Row>
      <CheckIt action={userActionsKeys.addVisitCommentSiteSummaryLegal}>
        <form className="col-12 col-sm-6 mb-2" onSubmit={handleSubmit((values) => {
          addSiteSummaryAction({...values, visitModelId: visitId}, () => {
            getVisit();
            setValue("comment", "")
          })
        })}>
          <Row>
            <div className="col-11 no-padding-right">
              <textarea className="form-control" name="comment" defaultValue="" ref={register({required: true})}/>
              <small className="text-danger" style={{position: "absolute", bottom: "-17px"}}>{errors.comment && "This field is required"}</small>
            </div>
            <div className="col-1 text-danger no-padding" style={{paddingLeft: "5px"}}>*</div>
          </Row>
          <input type="submit" className="btn btn-outline-secondary mt-3" value="Add Comment"/>
        </form>
      </CheckIt>
      {siteSummaries.length > 0 && <div className="col-12 col-sm-6">
        {siteSummaries.map((comment, index) => (
          <div className="col-12 mb-2 p-2 box-border" key={index + pagination.skip}>
            {comment.comment && <span dangerouslySetInnerHTML={{__html: comment.comment.replace(/\n/g, "<br/>")}}/>}
            <br/>
            <small className="text-gray">by {getName(comment.userName)} on {dateFormatMonthDayYearHoursMinute(comment.createDate)}</small>
          </div>
        ))}


        {siteSummaries.length > 0 && pagination.count > 10 &&
        <div style={{padding: "30px 15px 0", overflow: "auto"}}>
          <MyPagination count={pagination.count} limit={pagination.limit} skip={pagination.skip} action={(skip, limit) => {
            getVisit(limit, skip, pagination.filterName, pagination.columnSort, pagination.descending)
          }}/>
        </div>}

      </div>}
    </Row>
  );
};

export default SiteSummary;
